import React from "react";
import Header from "@/components/th/Header";
import Menu from "@/components/th/Menu";
import Footer from "@/components/th/Footer";
import FloatingButton from "@/components/th/FloatingButton";
import ScrollToTopFab from "@/components/th/ScrollToTopFab";
import ContactForm from "@/components/th/ContactForm";
import Link from "next/link";
import Image from "next/image";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CircleIcon from "@mui/icons-material/Circle";
import Stack from "@mui/material/Stack";
import IContact from "@/public/static/images/contact.png";

const breadcrumbs = [
  <Link key="1" href="/th/">
    หน้าแรก
  </Link>,
  <Typography key="2">ติดต่อสอบถาม</Typography>,
];
function Contactus() {
  return (
    <div className="wrapper">
      <Header />
      <Menu />
      <div className="coverMain">
        <div className="container">
          <div className="row">
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  noWrap
                  sx={{
                    mr: 2,
                    mb: 1,
                    fontFamily: "Prompt",
                    fontWeight: 800,
                    letterSpacing: ".1rem",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <CircleIcon
                    sx={{ mb: 1, mr: 2, fontSize: "18px", color: "#0179CC" }}
                  />
                  ติดต่อสอบถาม
                </Typography>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                  className="breadcrumbs"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>

      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="mb-4 fw-bold t-blue">
                ZENIYA (THAILAND) CO., LTD.
              </h4>
            </div>
            <div className="col-12 col-md-5 mb-5">
              <Image
                src={IContact}
                alt="contact"
                className="card-img"
                width={300}
              />
            </div>
            <div className="col-12 col-md-7 mb-5">
              <div className="row">
                <div className="col-12 mb-1">
                  <div className="list-about list-last">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          ที่อยู่
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <Typography variant="body1" gutterBottom>
                        นิคมอุตสาหกรรมอมตะซิตี้ ชลบุรี เฟส 8
                          <br />
                          700/750 หมู่ 1 อ.พานทอง จ.ชลบุรี 20160
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 mb-1">
                  <div className="list-about list-last">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          เบอร์โทรศัพท์
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <Typography variant="body1" gutterBottom>
                          03-818-5512-5
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 mb-1">
                  <div className="list-about list-last">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          ผู้รับผิดชอบ
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <Typography variant="body1" gutterBottom>
                          Mr.Fujiwara (JP/EN)
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                          อีเมล:
                          <a
                            className="t-blue mx-1 mb-0"
                            href="mailto:info@zeniya-thai.com"
                          >
                            info@zeniya-thai.com
                          </a>
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                          มือถือ: 08-1803-4856
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-contact">
          <div className="container">
            <div className="row">
              <div className="col-12 mb-4">
                <div className="heading">
                  <h1 className="heading_inner fw-bold text-center mb-4">
                    ติดต่อ<span className="t-blue">เรา</span>
                  </h1>
                </div>
              </div>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
      <FloatingButton />
      <ScrollToTopFab />
      <Footer />
    </div>
  );
}
export default Contactus;
